import { SimpleError } from '@simonbackx/simple-errors';
import { Formatter } from './Formatter';
export function checkIsDisabled(dateToCheck) {
    const disabledDates = [
        [new Date('07 13 2022 00:00:00 GMT+0200'), new Date('08 23 2022 23:59:59 GMT+0200')],
        [new Date('12 12 2022 00:00:00 GMT+0100'), new Date('01 12 2023 23:59:59 GMT+0100')],
        [new Date('04 10 2023 00:00:00 GMT+0100'), new Date('04 10 2023 23:59:59 GMT+0100')],
        [new Date('05 01 2023 00:00:00 GMT+0100'), new Date('05 01 2023 23:59:59 GMT+0100')],
        [new Date('05 29 2023 00:00:00 GMT+0100'), new Date('05 29 2023 23:59:59 GMT+0100')],
        [new Date('06 14 2023 00:00:00 GMT+0100'), new Date('06 25 2023 23:59:59 GMT+0100')],
        [new Date('07 03 2023 00:00:00 GMT+0100'), new Date('08 31 2023 23:59:59 GMT+0100')],
    ];
    for (const [startDate, endDate] of disabledDates) {
        if (dateToCheck.getTime() >= startDate.getTime() && dateToCheck.getTime() <= endDate.getTime()) {
            return {
                disabled: true,
                startDate,
                endDate
            };
        }
    }
    return {
        disabled: false,
        startDate: new Date(),
        endDate: new Date()
    };
}
export function checkIsWeekend(date) {
    if (date.getDay() == 0 || date.getDay() == 6) {
        return true;
    }
    return false;
}
export function isDateDisabled(dateToCheck, field) {
    const returnedObject = checkIsDisabled(dateToCheck);
    if (returnedObject.disabled) {
        throw new SimpleError({
            code: "invalid_date_disabled",
            message: `We kunnen u door drukte niet van dienst zijn van ${Formatter.date(returnedObject.startDate)} tot en met ${Formatter.date(returnedObject.endDate)}`,
            statusCode: 422,
            field: `${field}`
        });
    }
}
export function isWeekend(date, message, field) {
    if (checkIsWeekend(date)) {
        throw new SimpleError({
            code: "invalid_date_weekend",
            message: `Bestellingen kunnen niet ${message} worden in het weekend`,
            statusCode: 422,
            field: `${field}`
        });
    }
}
export function getFirstAvailableBusinessDay() {
    const date = new Date();
    date.setDate(date.getDate() + 8);
    if (date.getDay() == 0) {
        date.setDate(date.getDate() + 1);
    }
    if (date.getDay() == 6) {
        date.setDate(date.getDate() + 2);
    }
    date.setHours(9, 0, 0, 0);
    return date;
}
export function assertAfterFirstAvailableBusinessDay(date, message, field) {
    const firstDate = getFirstAvailableBusinessDay();
    if (date < firstDate) {
        throw new SimpleError({
            code: "invalid_field",
            message: `${message} is ten vroegste mogelijk op ${Formatter.dateTime(firstDate)}`,
            statusCode: 422,
            field,
        });
    }
}
//# sourceMappingURL=DisabledDates.js.map